import React from 'react';
import {
  RequestFormVisibility,
  useEmployeeRequestFormsQuery,
} from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';

type Props = {
  show: boolean;
  recordType: string;
  showAllRequests: boolean;
  onHide: () => void;
};

export const EmployeeRequestForm: React.FC<Props> = (props) => {
  const { data, loading } = useEmployeeRequestFormsQuery({
    skip: !props.show,
  });

  const requestFormsVisibleForEmployee =
    data?.requestForms.filter(
      (form) =>
        form.flair__Visibility__c === RequestFormVisibility.HrEmployee ||
        form.flair__Visibility__c === RequestFormVisibility.HrManagerEmployee,
    ) ?? [];

  return (
    <RequestForm
      {...props}
      requestForms={requestFormsVisibleForEmployee}
      employees={[]}
      isSelectEmployeeStepVisible={false}
      loading={loading}
    />
  );
};
